import React, { useContext, useEffect, useState, useRef } from "react";
import "./Manage_My_Points.css";
import { Form, Table } from "react-bootstrap";
import { set, useForm } from "react-hook-form";
import User_Info from "../../common_components/user_info/User_Info";
import { useDispatch, useSelector } from "react-redux";
import {
  AllAgentPanelText,
  AllReceviables,
  AllTransferable,
  Create,
  Status,
} from "../../../features/common/Slice";
import { Context } from "../../../utils/context";

import { FaEye, FaEyeSlash } from "react-icons/fa";
import AviatorCard from "./aviatorCard/AviatorCard";
import AviatorCardHindi from "./aviatorCardHindi/AviatorCardHindi";

const Manage_My_Points = () => {
  const containerRef = useRef(null);

  // Dynamic canvas autoscaling logic without hiding overflow
  useEffect(() => {
    const handleScale = () => {
      if (!containerRef.current) return;

      const baseWidth = 1060; // Base layout width target
      const windowWidth = window.innerWidth;

      if (windowWidth < baseWidth) {
        const scaleFactor = windowWidth / baseWidth;

        // Use 'zoom' for modern browsers to prevent clipping/overflow issues
        if ("zoom" in containerRef.current.style) {
          containerRef.current.style.zoom = scaleFactor;
          containerRef.current.style.transform = "none";
          containerRef.current.style.width = "100%";
        } else {
          // Fallback scale for browsers that do not support zoom
          containerRef.current.style.transform = `scale(${scaleFactor})`;
          containerRef.current.style.transformOrigin = "top left";
          containerRef.current.style.width = `${baseWidth}px`;
        }
      } else {
        containerRef.current.style.zoom = "1";
        containerRef.current.style.transform = "none";
        containerRef.current.style.width = "100%";
      }
    };

    window.addEventListener("resize", handleScale);
    handleScale();

    return () => window.removeEventListener("resize", handleScale);
  }, []);

  const [showPassword, setShowPassword] = useState(false);
  const dispatch = useDispatch();
  const receivables = useSelector((state) => state.common.all_receviable);
  const transferable = useSelector((state) => state.common.all_transferable);
  const transferpoints = useSelector((state) => state.common.common);

  const AgentPanelText = useSelector(
    (state) => state.common.all_agentpaneltext,
  );
  console.log(AgentPanelText, "AgentPanelText");

  const { GetUser } = useContext(Context);

  const [err, setErr] = useState("");
  const [success, setSuccess] = useState("");

  const transaction_status_id = {
    Accepted: 1,
    Pending: 3,
    Rejected: 2,
  };

  const [selectedRecIds, setSelectedRecIds] = useState([]);
  const [selectedTraIds, setSelectedTraIds] = useState([]);
  console.log("Receivables:", selectedRecIds);

  useEffect(() => {
    dispatch(AllReceviables());
    dispatch(AllTransferable());
  }, [dispatch]);

  const {
    register,
    handleSubmit,
    formState: { errors },
    setError,
    reset,
  } = useForm();

  const onSubmit = async (data) => {
    const formData = new FormData();
    formData.append("username", data.username);
    formData.append("password", data.password);
    formData.append("amount", data.amount);

    const result = await dispatch(Create(formData));

    if (result.payload.success) {
      await setErr("");
      await setSuccess("Points transferred successfully");
      dispatch(AllTransferable());
      setTimeout(() => {
        setSuccess("");
      }, 3000);
      reset();
    } else {
      await setError("username", {
        type: "manual",
        message: result.payload.errors.username?.msg,
      });
      await setError("password", {
        type: "manual",
        message: result.payload.errors.password?.msg,
      });
      await setError("amount", {
        type: "manual",
        message: result.payload.errors.amount?.msg,
      });
    }
  };

  const handleRecStatus = async (status) => {
    if (selectedRecIds.length === 0) {
      setErr("Please select at least one receivable.");
      setTimeout(() => {
        setErr("");
      }, 3000);
      return;
    }

    const formData = new FormData();
    formData.append("transaction_id", JSON.stringify(selectedRecIds));
    formData.append("transaction_status_id", status);

    const result = await dispatch(Status(formData));
    if (result.payload.success) {
      setSuccess("Success...!");
      setSelectedRecIds([]);
      await GetUser();
      dispatch(AllReceviables());

      setErr("");
      setTimeout(() => {
        setSuccess("");
      }, 3000);
    }
  };

  const handleTraStatus = async (status) => {
    if (selectedTraIds.length === 0) {
      setErr("Please select at least one transferable.");
      setTimeout(() => {
        setErr("");
      }, 3000);
      return;
    }

    const formData = new FormData();
    formData.append("transaction_id", JSON.stringify(selectedTraIds));
    formData.append("transaction_status_id", status);

    const result = await dispatch(Status(formData));
    if (result.payload.success) {
      dispatch(AllTransferable());
      setSuccess("Success...!");
      setSelectedTraIds([]);
      await GetUser();

      setErr("");
      setTimeout(() => {
        setSuccess("");
      }, 3000);
    }
  };

  useEffect(() => {
    dispatch(AllAgentPanelText());
  }, [dispatch]);

  /* Swapped properties so English goes on Left and Hindi on Right */
  const englishData = {
    badgeTitle: "Fun Aviator",
    introText: "We are thrilled to introduce our latest game",
    mainTitle: "Fun Aviator",
    bodyText:
      "To enjoy uninterrupted access, download the latest version of the app from https://mydgp.online",
    linkUrl: "https://mydgp.online/",
    linkText: "https://mydgp.online/",
  };

  const hindiData = {
    badgeTitle: "Fun Aviator",
    introText: "हम बेहद उत्साहित हैं अपने नए गेम",
    mainTitle: "Fun Aviator",
    bodyText:
      "को पेश करते हुए। बिना किसी रुकावट के इसका पूरा आनंद लेने के लिए, कृपया App का नया वर्जन इस लिंक से डाउनलोड करें:",
    linkUrl: "https://mydgp.online/",
    linkText: "https://mydgp.online/",
  };

  return (
    <div style={{ width: "100%", overflowX: "auto" }}>
      <div ref={containerRef}>
        <section className="Manage_My_Points">
          {/* User Info Header */}
          <div className="user_info_div">
            <div className="row me-0 ms-0 align-items-center">
              <div className="col-lg-3 col-sm-8 col-12 my-2">
                <User_Info />
              </div>
              <div className="col-lg-7 col-sm-1 col-0"></div>
              <div className="col-lg-2 col-sm-3 col-12 my-2 text-end">
                <b className="gray_text">
                  OTC is <span className="dar_blue_text">0.00</span>
                </b>
              </div>
            </div>
          </div>

          {/* 3-Column Layout: English Card | Form & Tables | Hindi Card */}
          <div className="note_info_div">
            <div className="note_info_div_section_holder">
              {/* Left Column: English Aviator Card */}
              <div className="AviatorCard_card_holder">
                <AviatorCard {...englishData} />
              </div>

              {/* Middle Column: Tables & Form */}
              <div className="AviatorCard_form_holder">
                {err && <div className="alert alert-danger">{err}</div>}
                {success && (
                  <div className="alert alert-success">{success}</div>
                )}

                <div className="manage_points_main_div">
                  <div className="title_div">
                    <p className="title_text mb-0">:: Manage My Points</p>
                    <div className="right_side">
                      <Form.Check
                        type="radio"
                        label="GK Points"
                        name="points"
                        defaultChecked
                      />
                      <Form.Check
                        type="radio"
                        label="Multiplayer Points"
                        name="points"
                      />
                    </div>
                  </div>

                  {/* Receivables & Transferable Tables */}
                  <div className="row_div">
                    <div className="div_holder">
                      <div className="light_gray_div">
                        <p className="gray_text mb-0">Receivables</p>
                        <div className="btn_holder">
                          <button
                            className="blue_btn"
                            onClick={() => dispatch(AllReceviables())}
                          >
                            Refresh
                          </button>
                        </div>
                      </div>
                      <div className="table-responsive gray_table">
                        <Table size="sm" bordered className="mb-0">
                          <thead>
                            <tr>
                              <th>Select</th>
                              <th>From Member</th>
                              <th>Amount</th>
                              <th>Type</th>
                            </tr>
                          </thead>
                          <tbody>
                            {receivables.length > 0 ? (
                              receivables.map((item, index) => (
                                <tr key={index}>
                                  <td>
                                    <Form.Check
                                      type="checkbox"
                                      checked={selectedRecIds.includes(item.id)}
                                      id={`rec-checkbox-${item.id}`}
                                      label=""
                                      onChange={(e) => {
                                        const isChecked = e.target.checked;
                                        setSelectedRecIds((prev) => {
                                          if (isChecked) {
                                            return [...prev, item.id];
                                          } else {
                                            return prev.filter(
                                              (id) => id !== item.id,
                                            );
                                          }
                                        });
                                      }}
                                    />
                                  </td>
                                  <td>{item?.User?.name}</td>
                                  <td>₹ {item?.amount}</td>
                                  <td>receive</td>
                                </tr>
                              ))
                            ) : (
                              <tr>
                                <td colSpan={4} className="text-center">
                                  No data available
                                </td>
                              </tr>
                            )}
                          </tbody>
                        </Table>
                      </div>
                      <div className="light_gray_div footer_div">
                        <Form.Check
                          type="checkbox"
                          label="Select All"
                          onChange={(e) => {
                            const isChecked = e.target.checked;
                            setSelectedRecIds(
                              isChecked
                                ? receivables.map((item) => item.id)
                                : [],
                            );
                          }}
                        />
                        <div className="btn_holder">
                          <button
                            className="blue_btn"
                            onClick={() =>
                              handleRecStatus(transaction_status_id.Accepted)
                            }
                          >
                            Receive
                          </button>
                        </div>
                        <div className="btn_holder">
                          <button
                            className="blue_btn"
                            onClick={() =>
                              handleRecStatus(transaction_status_id.Rejected)
                            }
                          >
                            Reject
                          </button>
                        </div>
                      </div>
                    </div>

                    <div className="div_holder">
                      <div className="light_gray_div">
                        <p className="gray_text mb-0">Transferable</p>
                        <div className="btn_holder">
                          <button
                            className="blue_btn"
                            onClick={() => dispatch(AllTransferable())}
                          >
                            Refresh
                          </button>
                        </div>
                      </div>
                      <div className="table-responsive gray_table">
                        <Table size="sm" bordered className="mb-0">
                          <thead>
                            <tr>
                              <th>Select</th>
                              <th>To Member</th>
                              <th>Amount</th>
                              <th>Type</th>
                            </tr>
                          </thead>
                          <tbody>
                            {transferable.length > 0 ? (
                              transferable.map((item, index) => (
                                <tr key={index}>
                                  <td>
                                    <Form.Check
                                      type="checkbox"
                                      checked={selectedTraIds.includes(item.id)}
                                      id={`tra-checkbox-${item.id}`}
                                      label=""
                                      onChange={(e) => {
                                        const isChecked = e.target.checked;
                                        setSelectedTraIds((prev) => {
                                          if (isChecked) {
                                            return [...prev, item.id];
                                          } else {
                                            return prev.filter(
                                              (id) => id !== item.id,
                                            );
                                          }
                                        });
                                      }}
                                    />
                                  </td>
                                  <td>{item?.TransferedUser?.name}</td>
                                  <td>₹ {item?.amount}</td>
                                  <td>transfer</td>
                                </tr>
                              ))
                            ) : (
                              <tr>
                                <td colSpan={4} className="text-center">
                                  No data available
                                </td>
                              </tr>
                            )}
                          </tbody>
                        </Table>
                      </div>
                      <div className="light_gray_div footer_div">
                        <Form.Check
                          type="checkbox"
                          label="Select All"
                          onChange={(e) => {
                            const isChecked = e.target.checked;
                            setSelectedTraIds(
                              isChecked
                                ? transferable.map((item) => item.id)
                                : [],
                            );
                          }}
                        />
                        <div className="btn_holder">
                          <button
                            className="blue_btn"
                            onClick={() =>
                              handleTraStatus(transaction_status_id.Rejected)
                            }
                          >
                            Cancel
                          </button>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>

                {/* Point Transfer Form */}
                <div className="manage_points_main_div mt-1">
                  <div className="title_div">
                    <p className="title_text mb-0">:: Point Transfer</p>
                  </div>

                  <div className="transfer_form_div">
                    <Form onSubmit={handleSubmit(onSubmit)}>
                      <div className="inputs_div">
                        <Form.Group className="common_form_group d-flex align-items-center mb-1">
                          <Form.Label className="form_label_custom me-1 mb-0">
                            To Account No. :
                          </Form.Label>
                          <Form.Control
                            type="text"
                            size="sm"
                            {...register("username", {
                              required: "Username is required",
                            })}
                          />
                        </Form.Group>
                        {errors?.username && (
                          <sub className="text-danger d-block mb-1">
                            {errors?.username.message}
                          </sub>
                        )}

                        <Form.Group className="common_form_group password_holder d-flex align-items-center mb-1">
                          <Form.Label className="form_label_custom me-1 mb-0">
                            Your Pin :
                          </Form.Label>
                          <div className="password_eye_field flex-grow-1 position-relative">
                            <Form.Control
                              type={showPassword ? "text" : "password"}
                              size="sm"
                              {...register("password", {
                                required: "Password is required",
                              })}
                            />
                            <span
                              className="password_eye_icon position-absolute end-0 top-50 translate-middle-y me-1"
                              onClick={() => setShowPassword(!showPassword)}
                              style={{ cursor: "pointer" }}
                            >
                              {showPassword ? <FaEyeSlash /> : <FaEye />}
                            </span>
                          </div>
                        </Form.Group>
                        {errors?.password && (
                          <sub className="text-danger d-block mb-1">
                            {errors?.password.message}
                          </sub>
                        )}

                        <Form.Group className="common_form_group d-flex align-items-center mb-1">
                          <Form.Label className="form_label_custom me-1 mb-0">
                            Amount :
                          </Form.Label>
                          <Form.Control
                            type="number"
                            size="sm"
                            {...register("amount", {
                              required: "Amount is required",
                            })}
                          />
                        </Form.Group>
                        {errors?.amount && (
                          <sub className="text-danger d-block mb-1">
                            {errors?.amount.message}
                          </sub>
                        )}
                      </div>

                      <div className="form_footer">
                        <div className="btn_holder">
                          <button type="submit" className="blue_btn">
                            Transfer
                          </button>
                        </div>
                        <p
                          className="close_text mb-0"
                          style={{ cursor: "pointer" }}
                        >
                          Close
                        </p>
                      </div>
                    </Form>
                  </div>
                </div>
              </div>

              {/* Right Column: Hindi Aviator Card */}
              <div className="AviatorCard_card_holder">
                <AviatorCardHindi {...hindiData} />
              </div>
            </div>
          </div>
        </section>
      </div>
    </div>
  );
};

export default Manage_My_Points;
